/**
 * ShoppingCartCtrl controller
 */

// controller mixins
import moment from 'moment'

ShoppingCartCtrl.mixes = ['onOffCtrlMixin']

const dragndropImg = new window.Image()
dragndropImg.src = require('./img/dragndrop.png')

/**
 * ShoppingCartCtrl controller
 *
 * @class ShoppingCartCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 * @mixes mwApp/common.mixin:onOffCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/packages.controller:ShoppingCartCtrl
 */
/* @ngInject */
export default function ShoppingCartCtrl ($scope, $uibModal, ShoppingCart, SubscriptionPlan, InappSubscription, Terms, Subscription, alertLiteSvc, authSvc, pckg, inapp) {
  var vm = this
  vm.mixes = [['tabsCtrlMixin', '', 'terms']]

  vm.activeTab = 0

  /**
   * Package/Network
   *
   * @memberof mwApp/packages.controller:ShoppingCartCtrl
   * @type {models.Network}
   */
  vm.pckg = pckg

  vm.isNew = vm.pckg?.id

  /**
   * Loader indicator
   *
   * @type {boolean}
   */
  $scope.loading = true

  /**
   * Default Package for in-app registration
   *
   * @memberof mwApp/packages.controller:ShoppingCartCtrl
   * @type {number}
   */
  vm.inappNetworkId = !inapp?.multiorgEnabled && inapp?.inAppRegistrationSettings?.enabled && inapp.inAppRegistrationSettings.network?.id

  /**
   * Default Package for Guest Mode
   *
   * @memberof mwApp/packages.controller:SubscriptionSettingsCtrl
   * @type {number}
   */
  vm.guestNetworkId = !inapp?.multiorgEnabled && inapp?.guestModeSettings?.enabled && inapp.guestModeSettings.network?.id

  // package id
  vm.pckg = pckg

  /**
   * Has access
   *
   * @memberOf mwApp/settings.controller:ShoppingCartCtrl
   * @function
   */
  vm.hasAccess = function (access) {
    return authSvc.hasAccess(access)
  }

  vm.inappSubscription = undefined

  vm.inAppEnabled = authSvc.hasEnabledFlag('IN_APP_SUBSCRIPTION_MANAGEMENT_ENABLED')

  if (vm.inAppEnabled) {
    InappSubscription.load({ networkId: vm.pckg.id }).then((result) => {
      vm.inappSubscription = result
      vm.inappSubscription.networkId = vm.pckg.id
    })
  }

  vm.loadShoppingCart = function (updatePlans = false) {
    ShoppingCart.load({ networkId: vm.pckg.id }).then(res => {
      if (updatePlans) {
        vm.sc.shoppingCartSubscriptionPlansSettings.forEach(plan => {
          plan.sortOrder = res.shoppingCartSubscriptionPlansSettings.find(p => p.subscriptionPlanSettingsId === plan.subscriptionPlanSettingsId).sortOrder
        })
      } else {
        vm.sc = res
        vm.sc.networkId = vm.pckg.id
        vm.sc.shoppingCartSubscriptionSettings.forEach(sub => {
          sub.$totalAmount = sub.amounts.reduce((acc, cur) => {
            if (['EXTRA_DEVICE', 'PRICE'].includes(cur.amountType)) {
              return acc + cur.amount
            } else return acc + 0
          }, 0)
        })
        vm.shoppingCartSubscriptions = angular.copy(vm.sc.shoppingCartSubscriptionSettings)
        let assignedSubscriptions = []
        vm.sc.shoppingCartSubscriptionPlansSettings.forEach(plan => {
          assignedSubscriptions = assignedSubscriptions.concat(plan.subscriptionSettings)
          plan.subscriptionSettings.forEach(sub => {
            sub.$totalAmount = sub.amounts.reduce((acc, cur) => {
              if (['EXTRA_DEVICE', 'PRICE'].includes(cur.amountType)) {
                return acc + cur.amount
              } else return acc + 0
            }, 0)
          })
          plan.id = plan.subscriptionPlanSettingsId
          plan.networkId = vm.sc.networkId
        })
        vm.shoppingCartSubscriptions = vm.shoppingCartSubscriptions.filter(s => !assignedSubscriptions.find(as => as.subscriptionId === s.subscriptionId))
      }
      $scope.loading = false
      vm.calculateHasActive()
    }).catch(() => {
      vm.sc = new ShoppingCart({ networkId: vm.pckg.id })
      $scope.loading = false
    })
  }
  vm.loadShoppingCart()

  /**
   * dnd-dragging determines what data gets serialized and send to the receiver
   * of the drop. While we usually just send a single object, we send the array
   * of all selected items here.
   */
  vm.getSelected = function (list, link) {
    link.selected = true
    return list.filter(link => link.selected)
  }

  /**
   * We set the list into dragging state, meaning the items that are being
   * dragged are hidden. We also use the HTML5 API directly to set a custom
   * image, since otherwise only the one item that the user actually dragged
   * would be shown as drag image.
   */
  vm.onDragstart = function (list, event) {
    list.dragging = true
    if (event.dataTransfer.setDragImage) {
      event.dataTransfer.setDragImage(dragndropImg, 0, 0)
    }
  }

  /**
   * Last but not least, we have to remove the previously dragged items in the
   * dnd-moved callback.
   */
  vm.onMoved = function (list) {
    vm.sc.shoppingCartSubscriptionSettings = list.filter(item => !item.selected)
  }

  /**
   * We set the list into dragging state, meaning the items that are being
   * dragged are hidden. We also use the HTML5 API directly to set a custom
   * image, since otherwise only the one item that the user actually dragged
   * would be shown as drag image.
   */
  vm.onDragend = function (list) {
    list.dragging = false
  }

  /**
   * In the dnd-drop callback, we now have to handle the data array that we
   * sent above. We handle the insertion into the list ourselves. By returning
   * true, the dnd-list directive won't do the insertion itself.
   */
  vm.onDrop = function (list, items, index) {
    vm.form.$setDirty()
    items.forEach(item => { item.selected = false })
    vm.sc.shoppingCartSubscriptionSettings = vm.sc.shoppingCartSubscriptionSettings
      .slice(0, index)
      .concat(items)
      .concat(list.slice(index))
    vm.sc.subscriptions = list.filter(item => !item.selected)
    return true
  }

  vm.deviceCount = function (amounts) {
    return amounts.filter(a => a.amountType === 'EXTRA_DEVICE').length + 1
  }

  vm.save = function () {
    vm.setDisable()
    vm.sc.shoppingCartSubscriptionSettings && vm.sc.shoppingCartSubscriptionSettings.forEach((sub, i) => {
      sub.sortOrder = i
    })
    const promises = [ShoppingCart.save(vm.sc, vm.pckg.id)]
    if (vm.inAppEnabled) {
      promises.push(vm.inappSubscription._save())
    }
    Promise.all(promises)
      .then(() => {
        vm.unsetDisable()
        vm.form.$setPristine()
        vm.loadShoppingCart()
      })
      .then(vm.location().reload)
      .catch(() => {
        vm.unsetDisable()
      })
  }

  /**
   * In the dnd-drop callback, we now have to handle the data array that we
   * sent above. We handle the insertion into the list ourselves. By returning
   * true, the dnd-list directive won't do the insertion itself.
   */
  vm.onDropGroup = function (list, items, index, to = '') {
    items.forEach(item => { item.selected = false })
    if (vm.from === 'plans') {
      if (to !== 'plans') {
        vm.sc.shoppingCartSubscriptionPlansSettings.forEach(plan => {
          plan.selected = false
        })
        return false
      }
      list.shoppingCartSubscriptionPlansSettings = list.shoppingCartSubscriptionPlansSettings
        .slice(0, index)
        .concat(items.map((p) => new SubscriptionPlan(p)))
        .concat(list.shoppingCartSubscriptionPlansSettings.slice(index))
      list.shoppingCartSubscriptionPlansSettings.forEach((plan, i) => {
        plan.sortOrder = i
      })
    } else {
      if (to === 'plans') {
        return false
      }
      if (to === 'available') {
        if (vm.from === 'available') {
          vm.shoppingCartSubscriptions.forEach((item) => { item.selected = false })
          return false
        }
        vm.shoppingCartSubscriptions = vm.shoppingCartSubscriptions
          .slice(0, index)
          .concat(items)
          .concat(vm.shoppingCartSubscriptions.slice(index))
      } else {
        list.subscriptionSettings = list.subscriptionSettings
          .slice(0, index)
          .concat(items)
          .concat(list.subscriptionSettings.slice(index))
      }
    }
    vm.form.$setDirty()
    return true
  }

  /**
   * dnd-dragging determines what data gets serialized and send to the receiver
   * of the drop. While we usually just send a single object, we send the array
   * of all selected items here.
   */
  vm.getSelectedGroup = function (list, link, local) {
    vm.localDnd = local
    link.selected = true
    return list.filter(link => link.selected)
  }

  /**
   * We set the list into dragging state, meaning the items that are being
   * dragged are hidden. We also use the HTML5 API directly to set a custom
   * image, since otherwise only the one item that the user actually dragged
   * would be shown as drag image.
   */
  vm.onDragstartGroup = function (list, from, event) {
    vm.from = from
    list.dragging = true
    if (event.dataTransfer.setDragImage) {
      event.dataTransfer.setDragImage(dragndropImg, 0, 0)
    }
  }

  /**
   * We set the list into dragging state, meaning the items that are being
   * dragged are hidden. We also use the HTML5 API directly to set a custom
   * image, since otherwise only the one item that the user actually dragged
   * would be shown as drag image.
   */
  vm.onDragendGroup = function (list) {
    vm.localDnd = false
    list.dragging = false
    vm.calculateHasActive()
  }

  /**
   * Last but not least, we have to remove the previously dragged items in the
   * dnd-moved callback.
   */
  vm.onMovedGroup = function (list, from = '') {
    if (from === 'subscriptions') {
      list.subscriptionSettings = list.subscriptionSettings.filter(item => !item.selected)
    } else if (from === 'plans') {
      list.shoppingCartSubscriptionPlansSettings = list.shoppingCartSubscriptionPlansSettings.filter(item => !item.selected)
    } else {
      vm.shoppingCartSubscriptions = vm.shoppingCartSubscriptions.filter(item => !item.selected)
    }
    vm.from = from
  }

  /**
   * Open add/edit Plan modal window
   *
   * @memberof mwApp/packages.controller:ShoppingCartCtrl
   */
  vm.addPlan = vm.editPlan = function (plan) {
    var isNew = !plan
    var initialPlan = angular.copy(plan) // initial state
    $uibModal.open({
      animation: false,
      templateUrl: 'components/packages/views/addSubscriptionPlan.html',
      controller: 'AddSubscriptionPlanCtrl as vm',
      size: 'lg',
      resolve: {
        plan: () => isNew ? new SubscriptionPlan({ networkId: vm.pckg.id }) : plan
      }
    }).result
      .then(function close (plan) {
        // $scope.form.$setDirty()
        if (isNew) {
          vm.sc.shoppingCartSubscriptionPlansSettings.unshift(plan)
        }
        vm.loadShoppingCart(true)
      }, function dismiss () {
        if (!isNew) {
          angular.copy(initialPlan, plan) // restore
        }
      })
  }

  /**
   * Create partner program
   *
   * @memberof mwApp/shoppingCart.controller:ShoppingCartCtrl
   * @function
   * @param  {models.ShoppingCart} sc
   * @param  {Boolean} error
   */
  vm.editSC = function (sc, error = false) {
    var initialSC = angular.copy(sc) // initial state
    $uibModal.open({
      templateUrl: 'components/packages/views/editShoppingCartSettings.html',
      controller: 'EditShoppingCartSettingsCtrl as vm',
      animation: false,
      size: 'lg',
      windowClass: 'sc-modal',
      resolve: {
        sc: function () {
          return sc
        },
        networkId: function () {
          return pckg.id
        },
        error: function () {
          return error
        }
      }
    }).result
      .then(
        function close () {
          vm.form.$setDirty()
        },
        function dismiss () {
          angular.copy(initialSC, sc) // restore catchup
          if (error) {
            sc.active = false
          }
        }
      )
  }

  vm.filter = ''
  vm.filterByHeading = function (subscription) {
    return vm.filter.length > 0
      ? subscription.heading?.toLowerCase().includes(vm.filter.toLowerCase()) ||
      subscription.promoLabel?.toLowerCase().includes(vm.filter.toLowerCase()) ||
      subscription.name?.toLowerCase().includes(vm.filter.toLowerCase())
      : true
  }

  vm.filterPlan = ''
  vm.filterPlanByName = function (plan) {
    return vm.filterPlan.length > 0 ? plan.name.toLowerCase().includes(vm.filterPlan.toLowerCase()) : true
  }

  vm.deletePlan = function (plan) {
    plan._delete().then(() => {
      vm.shoppingCartSubscriptions = vm.shoppingCartSubscriptions.concat(plan.subscriptionSettings)
      vm.sc.shoppingCartSubscriptionPlansSettings = vm.sc.shoppingCartSubscriptionPlansSettings.filter(p => p.id !== plan.id)
      vm.loadShoppingCart(true)
      vm.calculateHasActive()
    })
  }

  vm.calculateHasActive = function () {
    if (vm.sc.displaySubscriptionsType === 'BY_SUBSCRIPTION') {
      vm.hasActiveSubscription = vm.sc.shoppingCartSubscriptionSettings.reduce((acc, cur) => {
        return acc || cur.active
      }, false)
    } else {
      vm.hasActiveSubscription = vm.sc.shoppingCartSubscriptionPlansSettings.reduce((acc, plan) => acc || plan.subscriptionSettings.reduce((acc, cur) => acc || cur.active, false), false)
    }
  }

  vm.changeActive = function (link) {
    if (link.active && !link.heading) {
      vm.editSC(link, true)
    }
    vm.calculateHasActive()
  }

  vm.deleteSubscription = function (subscription, plan, index) {
    subscription.selected = false
    vm.shoppingCartSubscriptions.push(subscription)
    plan.subscriptionSettings.splice(index, 1)
    vm.form.$setDirty()
    vm.calculateHasActive()
  }

  vm.showLength = function (subscription) {
    if (subscription.periodUnlimited) {
      return 'Unlimited'
    } else if (subscription.dueDate) {
      return 'to: ' + moment(subscription.dueDate).format('DD.MM.YYYY')
    } else {
      return subscription.length + ' ' + subscription.lengthType[0].toUpperCase()
    }
  }

  Subscription.loadAll({ networkId: pckg.id })
    .then(data => data.filter(item => item.subscriptionType === 'Subscription'))
    .to(vm.subscriptions = [])

  vm.getTerms = function (tableState) {
    // set default sort by name
    if (!tableState.sort.predicate) {
      tableState.sort.predicate = 'subject'
      tableState.sort.reverse = false
    }
    if (!tableState.pagination.number) {
      tableState.pagination.number = 25
    }
    Terms.loadSmart(tableState, { networkId: vm.pckg.id })
      .then(data => {
        vm.terms = data.content.map(c => new Terms({ ...c, networkId: vm.pckg.id }))
        $scope.loading = false
      })
  }

  /**
   * Create partner program
   *
   * @memberof mwApp/shoppingCart.controller:ShoppingCartCtrl
   * @function
   * @param  {models.Terms} terms
   */
  vm.addTerms = vm.editTerms = function (terms) {
    var isNew = !terms
    var initialTerms = angular.copy(terms) // initial state
    $uibModal.open({
      templateUrl: 'components/packages/views/addTerms.html',
      controller: 'AddTermsCtrl as vm',
      animation: false,
      size: 'lg',
      resolve: {
        terms: function () {
          return !isNew
            ? Terms.load(terms).then(res => new Terms({ ...res, networkId: vm.pckg.id }))
            : new Terms({ networkId: vm.pckg.id })
        },
        networkId: function () {
          return vm.pckg.id
        }
      }
    }).result
      .then(
        function close () {
          $scope.$broadcast('refreshTable', { id: 'termsTable' })
        },
        function dismiss () {
          if (!isNew) {
            angular.copy(initialTerms, terms) // restore catchup
          }
        }
      )
  }

  vm.deleteTerms = function (terms) {
    terms._delete().then(() => {
      $scope.$broadcast('refreshTable', { id: 'termsTable' })
    })
  }
}
